<template>
    <section id="configurator" class="flexContainer fd-c" style="width: 100%">
        <ProductSelect v-if="displayProductSelect" :position="position"></ProductSelect>
        <TicketStripSelect :ticketStrips="this.proptickets" v-if="displayTicketStripSelect"></TicketStripSelect>
        <div class="content-bbar">
            <div class="buttonbar-left">
                <div class="configuratorBox">
                    <div class="inputBox">
                        <label class="form-check-label" for="configWidth">Width</label>
                        <input type="number" step="1" min="0" id="configWidth" v-model="configWidth" />
                    </div>

                    <div class="inputBox">
                        <label class="form-check-label" for="configHeight">Height</label>
                        <input type="number" step="1" min="0" id="configHeight" v-model="configHeight" />
                    </div>

                    <div class="snapCheckbox">
                        <input type="checkbox" v-model="snapUp" class="form-check-input" id="snapUp" />
                        <label class="form-check-label" for="snapUp">Snap Up</label>
                    </div>
                </div>
                <button class="btn" @click="cleanConfig();">{{ $t("configurator.cleanConf") }}</button>
            </div>
            <div class="buttonbar-right">
                <button class="btn" @click="save(false);">{{ $t("configurator.save") }}</button>
                <button class="btn" @click="save(true);">{{ $t("configurator.saveClose") }}</button>
                <button class="btn" @click="close();">{{ $t("configurator.close") }}</button>
            </div>
        </div>
        <svg id="builderConfigurator" class="builder-configurator-module"></svg>
        <div class="buttonbar">
            <button class="btn" @click="confirmGroup">{{ $t("configurator.confirmGroup") }}</button>
        </div>
    </section>
</template>
<script>
import { componentMixin } from "../plano/mixins/component";

const d3 = require("d3"); // eslint-disable-line no-unused-vars
import Globals from "../globals.js"; // eslint-disable-line no-unused-vars
import { mapGetters, mapActions } from "vuex";
import { utilsMixin } from "../plano/mixins/utils";
import ProductSelect from "./ProductSelect";
import TicketStripSelect from "./TicketStripSelect";

export default {
    components: {
        ProductSelect,
        TicketStripSelect
    },
    mixins: [componentMixin, utilsMixin],
    data() {
        return {
            item: null,
            snapUp: false,
            configWidth: 0,
            configHeight: 0,
            groups: [],
            tickets: [],
            proptickets: [],
            pathsSelected: [],
            ticketSelected: null,
            modeSelectedTester: false,
            svgModule: null,
            groupSelected: null,
            displayProductSelect: false,
            displayTicketStripSelect: false,
            position: 1
        };
    },
    computed: {
        ...mapGetters({})
    },
    created() {},
    mounted() {
        let id = this.$route.params.id;

        this.getDetails({ id: id }).then(res => {
            this.item = res;
            this.loadModule();
        });

        this.$on("selected_tester", () => {
            this.reloadModule(this.item.config);
        });
    },
    methods: {
        ...mapActions({
            getDetails: "items/getDetails"
        }),
        reloadModule(config) {
            d3.select("svg#builderConfigurator")
                .select("svg")
                .remove();
            let clone = this.svgModule.cloneNode(true);
            let svgMain = document.getElementById("builderConfigurator");
            svgMain.appendChild(clone);
            this.cleanModule(clone);
            this.loadConstructPath(clone, config);
            this.loadConstructTicket(clone, config);
            this.addListeners(clone);
            this.pathsSelected = [];
        },
        cleanConfig() {
            this.groupSelected = null;
            this.item.config = {
                groups: [],
                tickets: []
            };
            this.configWidth = 0;
            this.configHeight = 0;
            this.snapUp = false;
            this.groups = this.item.config.groups;
            this.tickets = this.item.config.tickets;
            this.reloadModule(this.item.config);
        },

        callbackTester(products, tester, position = 0) {
            this.groupSelected.products = products;
            this.groupSelected.position = position;
            if (tester) {
                this.modeSelectedTester = true;
            } else {
                this.modeSelectedTester = false;
                this.$emit("selected_tester");
            }
        },

        callbackTicketStrip(tickets) {
            let ticket = this.tickets.filter(res => {
                return res.idElt === this.ticketSelected;
            });
            if (ticket.length > 0) {
                ticket[0].tickets = tickets;
            } else {
                this.tickets.push({
                    idElt: this.ticketSelected,
                    tickets: tickets
                });
            }
        },

        confirmGroup() {
            if (this.pathsSelected.length === 0) {
                return;
            }
            let valid = false;
            this.groups.sort((g1, g2) => {
                if (g1.position !== undefined && g2.position !== undefined) {
                    valid = true;
                    return g2.position - g1.position;
                } else {
                    return 0;
                }
            });

            if (valid) {
                this.position = this.groups[0].position + 1;
            } else {
                this.position = 1;
            }

            this.pathsSelected.forEach(path => {
                let group = this.groups.find(g => {
                    let mod = g.modules.find(m => {
                        return m === path;
                    });

                    return mod !== undefined;
                });
                if (group) {
                    this.groups.splice(this.groups.indexOf(group), 1);
                }
            });
            let g = {
                modules: this.assign(this.pathsSelected)
            };
            this.groupSelected = g;
            this.groups.forEach(group => {
                delete group.rowId;
            });

            this.groups.push(g);
            this.displayProductSelect = true;
            // this.$swal({
            //     title: '',
            //     text: this.$t('configurator.messageAlert1'),
            //     type: 'warning',
            //     showCancelButton: true,
            //     confirmButtonColor: '#41b4e8',
            //     confirmButtonText: 'Oui',
            //     cancelButtonText: 'Non'
            // }).then((result) => {
            //     if (result === true) {
            //         this.modeSelectedTester = true
            //     } else {
            //         this.modeSelectedTester = false
            //         this.$emit('selected_tester')
            //     }
            // }).catch(() => {
            //     this.modeSelectedTester = false
            //     this.$emit('selected_tester')
            // })

            //                let g = {
            //                    modules: this.pathsSelected
            //                }
            //                this.groups.push(g)
        },
        loadModule() {
            if (this.item.config) {
                if (this.item.config.snapUp) {
                    this.snapUp = this.item.config.snapUp;
                }
                if (this.item.config.width) {
                    this.configWidth = this.item.config.width;
                }
                if (this.item.config.height) {
                    this.configHeight = this.item.config.height;
                }
                if (this.item.config.groups) {
                    this.groups = this.item.config.groups;
                } else {
                    this.item.config.groups = [];
                    this.groups = this.item.config.groups;
                }

                if (this.item.config.tickets) {
                    this.tickets = this.item.config.tickets;
                } else {
                    this.item.config.tickets = [];
                    this.tickets = this.item.config.tickets;
                }
            } else {
                this.item.config = {
                    groups: [],
                    tickets: []
                };

                this.groups = this.item.config.groups;
                this.tickets = this.item.config.tickets;
            }

            let path = this._.find(this.item.figures_advanced, o => {
                return o.id_type_file === 6;
            });

            let url = Globals.getBaseUrl() + path.big;
            this.url = url;
            this.eltSvg(url).then(domXml => {
                this.svgModule = domXml;
                let clone = this.svgModule.cloneNode(true);
                let svgMain = document.getElementById("builderConfigurator");
                svgMain.appendChild(clone);
                this.cleanModule(clone);
                this.loadConstructPath(clone, this.item.config);
                this.loadConstructTicket(clone, this.item.config);
                this.addListeners(clone);
            });
        },
        addListeners(svg) {
            let gContentPaths = d3.select(svg).select("g#FILL");
            gContentPaths.raise();

            let paths = gContentPaths.selectAll("path");
            paths.each((d, i, cmps) => {
                d3.select(cmps[i]).data([{ selected: false }]);
            });
            paths.on("click", (d, i, cmps) => {
                if (this.modeSelectedTester === true) {
                    if (this.groupSelected.modules.includes(cmps[i].id)) {
                        this.modeSelectedTester = false;
                        this.groupSelected.tester = cmps[i].id;
                        d3.select(cmps[i]).classed("tester", true);
                        this.$emit("selected_tester");
                        this.groupSelected = null;
                    } else {
                        this.$swal({
                            title: this.$t("configurator.warning"),
                            text: this.$t("configurator.messageAlert2"),
                            type: "warning",
                            //                                showCancelButton: true,
                            confirmButtonColor: "#41b4e8",
                            confirmButtonText: "Ok"
                            // cancelButtonText: 'Non'
                        });
                    }
                } else {
                    let selected = !d.selected;
                    d.selected = selected;
                    if (selected) {
                        this.pathsSelected.push(cmps[i].id);
                    } else {
                        this.pathsSelected.splice(this.pathsSelected.indexOf(cmps[i].id), 1);
                    }
                    d3.select(cmps[i])
                        .classed("selected", selected)
                        .classed("tester", false);
                }
            });

            let gContentTicketStrip = d3.select(svg).select("g#TICKET_STRIPS");
            let rectsTicket = gContentTicketStrip.selectAll("rect");
            rectsTicket.each((d, i, cmps) => {
                d3.select(cmps[i]).data([{ selected: false }]);
            });
            rectsTicket.on("click", (d, i, cmps) => {
                let selected = true;
                d.selected = selected;

                let cmp = cmps[i];
                d3.select(cmp).classed("selected", selected);
                this.proptickets = this.tickets.filter(ticket => {
                    return ticket.idElt === cmp.id;
                });
                this.ticketSelected = cmp.id;
                this.displayTicketStripSelect = true;
            });
        },
        close() {
            let url = "/" + this.item.type + "/" + this.item.id;
            this.$router.push(url);
        },
        save(close) {
            this.$swal({
                title: this.$t("configurator.warning"),
                text: this.$t("configurator.messageAlert3"),
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#41b4e8",
                confirmButtonText: "Oui",
                cancelButtonText: "Non"
            }).then(res => {
                if (res) {
                    // let tickets =
                    // this.items.config.tickets.length
                    // if (this.tickets && this.tickets.length === 1) {
                    //     let ticket = {
                    //         idElt: this.tickets[0].idElt,
                    //         ...this.tickets[0].tickets[0]
                    //     }
                    //     this.item.config.ticket = ticket
                    // } else {
                    //     this.item.config.ticket = null
                    // }
                    this.item.config.snapUp = this.snapUp;
                    this.item.config.width = this.configWidth;
                    this.item.config.height = this.configHeight;
                    this.$store
                        .dispatch("items/setModuleConfig", {
                            id: this.item.id,
                            config: this.item.config
                        })
                        .then(() => {
                            if (close) {
                                this.close();
                            }
                        });
                }
            });
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/themes";
#configurator {
    flex: 1 0 100%;
    height: calc(100vh - 250px);
    @extend %primary-text;
}

.content-bbar {
    display: flex;
    padding: 10px;
    width: 100%;
}

.buttonbar {
    padding: 2px;
    text-align: center;
}

.buttonbar-left {
    flex: 1;
    padding: 2px;
}

.buttonbar-right {
    text-align: right;
    padding: 2px;
}

.builder-configurator-module {
    flex: 1 0 100%;
    height: calc(100vh - 200px);
    width: 100%;
    path.grouped {
        stroke: limegreen;
        stroke-width: 4px;
        stroke-dasharray: 10px;
    }
    path.selected {
        stroke: red;
        stroke-width: 2px;
        stroke-dasharray: 0;
    }
    path.tester {
        stroke: blue;
        stroke-width: 2px;
    }

    rect.selected {
        stroke: #2954a0 !important;
        stroke-width: 2px;
        stroke-dasharray: 0;
    }
}
.configuratorBox {
    padding-left: 5px;
    margin-bottom: 10px;
    .snapCheckbox {
        display: inline-block;
        margin-left: 5px;
        vertical-align: middle;
        font-size: 30px;
    }

    .inputBox {
        font-size: 30px;
        margin: 5px 0px;

        * {
            vertical-align: baseline;
        }
        input {
            background-color: transparent;
            border: none;
            border-bottom: 1px #000 solid;
            @extend %primary-border-color;
            @extend %primary-text;
            padding-bottom: 0;
        }
        label {
            font-weight: bold;
            margin-right: 5px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// Configurator.vue?4dbfd042